import Image from "next/image";
import { QueueBrandPanel } from "@/components/queue/QueueBrandPanel";
import { QueueStatusPill } from "@/components/queue/QueueStatusPill";

type QueueListCardProps = {
  image: string;
  backgroundColor: string;
  title: string;
  progress: number;
  peopleAhead: number;
  status: {
    tone: "success" | "warning" | "info";
    title: string;
    text: string;
  };
  onCancel?: () => void;
  cancelDisabled?: boolean;
  color: string;
  isPaused?: boolean;
  isCalled?: boolean;
};

export function QueueListCard({
  image,
  backgroundColor,
  title,
  progress,
  peopleAhead,
  status,
  onCancel,
  cancelDisabled = false,
  color,
  isPaused = false,
  isCalled = false,
}: QueueListCardProps) {
  const formattedPeopleAhead = peopleAhead.toLocaleString("pt-BR");

  return (
    <article className="rounded-[8px] bg-[#eeeeee] p-[12px] text-black">
      <QueueBrandPanel
        image={image}
        backgroundColor={backgroundColor}
        color={color}
        title={title}
      />

      {/*{!isCalled && (
        <>*/}
      {/* Contador */}
      <div className="mt-[14px] text-center">
        <p className="text-[52px] font-black leading-none tracking-tight">
          {formattedPeopleAhead}
        </p>
        <p className="mt-[4px] text-[13px] leading-none">
          pessoas na sua frente
        </p>
      </div>
      {/* Barra de progresso com ícone */}
      <div className="relative mx-[4px] mt-[14px] h-[16px] rounded-full bg-[#d9d9d9]">
        <div
          className="h-full rounded-[4px] transition-[width] duration-300"
          style={{ width: `${progress}%`, backgroundColor: "#FEC822" }}
        />
        <div
          className="absolute top-1/2 h-[18px] w-[18px] -translate-x-1/2 -translate-y-1/2"
          style={{ left: `${progress}%` }}
        >
          <Image
            src="/ball-progress.png"
            alt="Progresso"
            fill
            className="object-contain object-center"
            unoptimized
          />
        </div>
      </div>
      {/*</>
      )}*/}

      <QueueStatusPill {...status} />

      {isPaused && (
        <div className="mt-[14px] rounded-lg border border-red-200 bg-red-50 px-3 py-2.5 text-center text-[13px] leading-snug text-red-600">
          A fila está temporariamente pausada, mas voltará em breve. Se você já
          estava na fila, não se preocupe: sua posição está garantida e será
          mantida assim que o sistema for retomado.
        </div>
      )}

      {/* Cancelar */}
      <div className="mt-[10px] pb-[2px] text-center">
        <button
          type="button"
          onClick={onCancel}
          disabled={cancelDisabled}
          className="cursor-pointer text-[13px] leading-none underline underline-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Cancelar
        </button>
      </div>
    </article>
  );
}
